export function buildPhotoShortcode({ kind = 'photo', photoId, galleryType, galleryValue, startId, includeStart = false }) {
  if (kind === 'photo') {
    if (includeStart && startId) {
      return `[[photo:${photoId}@start:${startId}]]`
    }
    return `[[photo:${photoId}]]`
  }

  const payload = `${galleryType}:${galleryValue}`
  if (includeStart && startId) {
    return `[[photos:${payload}@start:${startId}]]`
  }
  return `[[photos:${payload}]]`
}

export const PHOTO_SHORTCODE_REGEX = /\[\[(photo|photos):([^\]]+)\]\]/g

export function parsePhotoShortcodes(content = '') {
  if (!content) {
    return []
  }

  const matches = []
  const regex = new RegExp(PHOTO_SHORTCODE_REGEX.source, 'g')
  let match = regex.exec(content)

  while (match) {
    const kind = match[1]
    const inner = match[2].trim()
    const startSplit = inner.split('@start:')
    const payload = startSplit[0].trim()
    const startId = startSplit[1] ? +startSplit[1] : undefined

    matches.push({
      raw: match[0],
      kind,
      payload,
      startId: Number.isFinite(startId) ? startId : undefined,
    })

    match = regex.exec(content)
  }

  return matches
}

export function describePhotoShortcode(shortcode = '') {
  const parsed = parsePhotoShortcodes(shortcode)[0]
  if (!parsed) {
    return shortcode
  }

  if (parsed.kind === 'photo') {
    return `Фото #${parsed.payload}`
  }

  const [type, ...rest] = parsed.payload.split(':')
  const value = rest.join(':')
  const typeLabels = {
    bib: 'номер',
    custom: 'тег',
    album: 'альбом',
  }

  return `Галерея · ${typeLabels[type] || type} · ${value}`
}

export function hasPhotoShortcodes(content = '') {
  return new RegExp(PHOTO_SHORTCODE_REGEX.source).test(content)
}
